import Modal, { ModalProps } from "components/Modal/Modal";
import React from "react";
import {
  ResponsiveSanityImage,
  SanityImageRatio
} from "@silversea-ssc/ui-components-react";
import { HotelOrLandProgrammeFragment } from "types/graphql-types";
import { usePrePostHotelModalContent } from "./usePrePostHotelModalContent";
import { Trans } from "@lingui/macro";
import * as styles from "./PrePostProgrammeModal.module.scss";
import { ModalBody, ModalBodyTitle } from "@silversea-ssc/ui-components-react";

export interface PrePostProgrammeModalProps extends ModalProps {
  programme: HotelOrLandProgrammeFragment;
}

const PrePostProgrammeModal: React.FC<PrePostProgrammeModalProps> = ({
  modal,
  programme
}) => {
  const { name, code } = programme;
  const { data } = usePrePostHotelModalContent(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    programme.__typename!,
    code
  );

  return (
    <Modal
      title={name || ""}
      modal={modal}
      size="medium"
      data-content-name={`modal_pre_post_hotel_${code}`}
    >
      <ModalBody variant="wide">
        {data?.result && data.result.image && (
          <React.Fragment>
            <SanityImageRatio ratio="auto" image={data.result.image}>
              <ResponsiveSanityImage
                image={data.result.image}
                defaultWidth={800}
                defaultHeight={450}
                fit="original"
                //imgStyle={{ objectFit: "contain" }}
              />
            </SanityImageRatio>
            <br />
          </React.Fragment>
        )}
        <ModalBodyTitle>{name}</ModalBodyTitle>
        <p>
          <Trans>Code</Trans>: {code}
        </p>
        <br />
        {data?.result && data.result.descriptionHtml && (
          <div
            dangerouslySetInnerHTML={{ __html: data.result.descriptionHtml }}
            className={styles.content}
          />
        )}
        <br />
      </ModalBody>
    </Modal>
  );
};

export default PrePostProgrammeModal;
